import { useIntl } from 'react-intl';

import { FieldValues, FormProvider, UseFormReturn } from 'react-hook-form';
import { Grid } from '@mui/material';

import { getDropdownOptionList } from 'ui-component/RecordView/utils';

import { FORM_SECTION_DEFINITIONS } from '../assets';

import { FormSection } from './FormSection';
import { FormInput } from './FormInput';

import { IRecordFieldsList } from 'ui-component/records/types';
import { ListValue } from 'views/backoffice/CustomLists/types';
import { IProblemCode, IRecordStatus } from 'ui-component/RecordView/types';
import { IUser } from 'views/backoffice/users/types';

export type RecordFormProps = {
    headers: IRecordFieldsList | undefined;
    methods: UseFormReturn<FieldValues, any>;
    listValuesByListId: {
        [x: number]: ListValue[];
    };
    problemCodeList: IProblemCode[];
    recordStatusList: IRecordStatus[];
    usersList: IUser[];
};

export const RecordForm = ({ headers, methods, listValuesByListId, problemCodeList, recordStatusList, usersList }: RecordFormProps) => {
    const intl = useIntl();

    return (
        <FormProvider {...methods}>
            <div data-testid="create-record-form">
                {Object.entries(FORM_SECTION_DEFINITIONS).map(([key, fields], idx) => (
                    <FormSection key={key} title={intl.formatMessage({ id: key })}>
                        <Grid container spacing={2} sx={{ width: '100%' }}>
                            {fields.map((fieldData) => {
                                const listType = headers?.[fieldData.fieldName as string]?.listType;
                                const isDropdown = headers?.[fieldData.fieldName as string]?.dataType.toLowerCase() === 'dropdown';
                                const options = listType
                                    ? listValuesByListId[Number(listType.id)]
                                    : getDropdownOptionList(fieldData.fieldName as any, [], recordStatusList, problemCodeList, usersList);
                                return (
                                    <Grid key={fieldData.fieldName} item xs={fieldData.columns}>
                                        <FormInput
                                            label={
                                                (fieldData.label as string) ||
                                                intl.formatMessage({ id: fieldData.fieldName, defaultMessage: fieldData.fieldName })
                                            }
                                            name={fieldData.fieldName}
                                            fieldDef={headers?.[fieldData.fieldName as string]}
                                            options={isDropdown ? options : undefined}
                                            isCustomList={!!listType}
                                            resetField={methods.resetField}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </FormSection>
                ))}
            </div>
        </FormProvider>
    );
};
